import {BlobUpload, User} from 'data/types'

export function uint8ArrayToBase64(source: Uint8Array): string {
  return btoa(new Uint8Array(source).reduce((data, byte) => data + String.fromCharCode(byte), ''))
}

export function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

type ReadFileMethod = 'readAsDataURL' | 'readAsArrayBuffer' | 'readAsBinaryString' | 'readAsText'

export function readFile<T extends File>(file: T, method: ReadFileMethod = 'readAsDataURL') {
  return new Promise<BlobUpload>((fulfill) => {
    // Initialize FileReader browser API
    const reader = new FileReader()
    // onload callback gets called after the reader reads the file data
    reader.onloadend = (e: any) => {
      let target = e.target.result
      if (method === 'readAsDataURL') {
        target = target.split('base64')[1].slice(1)
      }
      fulfill({contentType: file.type, content: target})
    }
    // Read the file as Data URL (since we accept only images)
    reader[method](file)
    return file
  })
}

export {default as Cache} from './cache'

export function userAvatarColor(user: User): string {
  return `rgba(${user.avatarColor.red}, ${user.avatarColor.green}, ${user.avatarColor.blue}, ${user.avatarColor.alpha})`
}
